import type { Recency } from "@/types/concept";

export interface DirectionWeights {
  references: number;
  citations: number;
  recommendations: number;
  /** Works the seed's citers also cite (OpenAlex): stands in for the
   *  references of seeds that have none, e.g. classic humanities books. */
  cocited: number;
}
export type DirectionLimits = DirectionWeights;

// Spec §3 trawl direction weights; tuned on preview composition at the setup gate.
export const RECENCY_WEIGHTS: Record<Recency, DirectionWeights> = {
  classic: { references: 1, citations: 0.5, recommendations: 0, cocited: 0.5 },
  balanced: { references: 1, citations: 1, recommendations: 0.5, cocited: 0.5 },
  recent: { references: 0.3, citations: 1, recommendations: 1, cocited: 0 },
};

/** Papers fetched per seed per direction in the setup preview (before weights). */
export const PREVIEW_PER_DIRECTION = 60;

export function directionLimits(recency: Recency | undefined, base = PREVIEW_PER_DIRECTION): DirectionLimits {
  const w = RECENCY_WEIGHTS[recency ?? "balanced"];
  return {
    references: Math.round(base * w.references),
    citations: Math.round(base * w.citations),
    recommendations: Math.round(base * w.recommendations),
    cocited: Math.round(base * w.cocited),
  };
}
